import React, { useState, useEffect } from "react";
import Menu from "../Menu";
import { http } from "../../services/http";
import { useAlert } from "react-alert";
import { PagingState, EditingState, CustomPaging, FilteringState, DataTypeProvider } from "@devexpress/dx-react-grid";
import { Grid, Table, TableHeaderRow, PagingPanel, TableEditRow, TableEditColumn, TableColumnVisibility, TableFixedColumns } from "@devexpress/dx-react-grid-material-ui";
import { QueryString, TIMER_FILTER } from "../utils/react_grid_utils";
import authenticatedUserContext from "../security/AuthenticatedUserContext";
import SettingsIcon from '@mui/icons-material/Settings';
import SmartToyIcon  from "@mui/icons-material/SmartToy";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import CodeIcon from '@mui/icons-material/Code';
import FaceIcon from '@mui/icons-material/Face';
import { Alert, InputAdornment, Grid as MIUGrid, Snackbar, Tooltip} from '@mui/material'
import { styled } from '@mui/material/styles';

import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import CookieService from "../../services/CookieService";
import Divider from '@mui/material/Divider';
import TextField from "@material-ui/core/TextField";
import { Box, Typography } from '@mui/material';
import { Add, DateRange, Delete, List } from "@material-ui/icons";
import { MenuItem } from "@material-ui/core";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import { green, red } from '@mui/material/colors';
import { ContentCopy } from "@mui/icons-material";
import Header from "../Header";


let user = CookieService.get("user");
const emailAdmin = process.env.REACT_APP_EMAIL_ADMIN;
const getRowId = (row) => row.id;
const api_resource = "/bots";

const DateFormatter = ({ value }) => {
  if (!value) return "";
  const date = new Date(value);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${day}/${month}/${year}`;
};

const StringToolTipProvider = ({ value }) =>(
  value ? 
    <Tooltip title={value}> 
      {value}
    </Tooltip>
    : 
    <Tooltip title=''> 
      {''}
    </Tooltip>
)

const StringTypeProvider = (props) => (
  <DataTypeProvider
    formatterComponent={StringToolTipProvider}
    {...props}
  />
);

const DateTypeProvider = (props) => (
  <DataTypeProvider
    formatterComponent={DateFormatter}
    {...props}
  />
);

const BooleanFormatter = ({ value }) => (
  value ? 
    <Tooltip title="Ativo">
      <CheckCircleIcon style={{ color: green[500] }} /> 
    </Tooltip>
    : 
    <Tooltip title="Inativo">
      <CancelIcon style={{ color: red[500] }} />
    </Tooltip>
    
);

// Tipo customizado que usa apenas o BooleanFormatter para visualização
const BooleanTypeProvider = (props) => (
  <DataTypeProvider
    formatterComponent={BooleanFormatter}
    {...props}
  />
);

const TextFieldLegivel = styled(TextField)(({ theme }) => ({
  '& .MuiInputBase-input.Mui-disabled': {
    WebkitTextFillColor: 'black',
    color: 'black',
    opacity: 1,
  },
  '& .MuiInputLabel-root.Mui-disabled': {
    color: 'rgba(0, 0, 0, 0.6)',
  },
}));

const PasswordFormatter = ({ value }) => {
  if (value === null || value === undefined || value === "") return "";
  return "******";
};

const PasswordEditor = ({ value, onValueChange }) => (
  <input
    type="password"
    value={value || ""}
    onChange={(e) => onValueChange(e.target.value)}
  />
);

const PasswordTypeProvider = (props) => (
  <DataTypeProvider
    formatterComponent={PasswordFormatter}
    editorComponent={PasswordEditor}
    {...props}
  />
);

const TypeFormatter = ({ value }) => {
  return  (
    <Tooltip title="Bot">
      <SmartToyIcon />
    </Tooltip>
  )
};

const TypeProvider = (props) => (
  <DataTypeProvider
    formatterComponent={TypeFormatter}
    {...props}
  />
);


const BotTable = () => {
  const alert = useAlert();
  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize] = useState(15);
  const [totalItens, setTotalItens] = useState(0);
  const [rows, setRows] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);
  const [editingRowIds, setEditingRowIds] = useState([]);
  const [defaultHiddenColumnNames, setDefaultHiddenColumnNames] = useState(["id"]);
  const [addedRows, setAddedRows] = useState([]);
  const [rowChanges, setRowChanges] = useState({});
  const [filters, setFilters] = useState([]);

  const [tableColumnExtensions] = useState([
    { columnName: "type", width: '75px' },
    { columnName: "enable", width: '60px' },
    { columnName: "created_at", width: '100px' },
    { columnName: "name", width:'200px' },
    { columnName: "responsible_name", width:'200px' },
    { columnName: "developer_name", width:'200px' },
    { columnName: "document_name", width:'250px' },
    //{ columnName: "description", width: '20%' },
  ]);

  const columns = [
    { name: "type", title: "Tipo", getCellValue: (row) => row.type === 'bot' ? 'Bot' : 'Automação' },
    { name: "enable", title: "Status" },
    { name: "created_at", title: "Data Criação"},
    { name: "name", title: "Nome" },
    { name: "developer_name", title: 'Desenvolvedor'},
    { name: "responsible_name", title: 'Responsável'},
    { name: "document_name", title: "Documentação" },
    { name: "description", title: "Descrição" },
    
    
    
  ];

  const [bots, setBots] = useState([]);
  const [rowTypes, setRowTypes] = useState({});
  const [userAccess, setUserAccess] = useState([]);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  //
  const [id, setId] = useState(0)
 
  const [name, setName] = useState('')
  const [description, setDescription] = useState('')
  const [type, setType] = useState('bot')
  const [status, setStatus] = useState(true)
  const [developerName, setDeveloperName] = useState('')
  const [responsibleName, setResponsibleName] = useState('')
  const [curDocument, setCurDocument] = useState()
  const [curFileName, setCurFileName] = useState(true)
  const [newFilePath, setNewFilePath] = useState('')
  const [newFile, setNewFile] = useState('')
  const [createdAt, setCreatedAt] = useState('')
  const [updatedAt, setUpdatedAt] = useState('')


  const handleCloseSnackbar = () => {
    setSnackbarOpen(false);
  };


  const formatDateTime = (dateTime) => {
    const date = new Date(dateTime);
    const formattedDate = date.toLocaleDateString("pt-BR"); // Formato DD/MM/YYYY
    const formattedTime = date.toLocaleTimeString("pt-BR", { hour: '2-digit', minute: '2-digit' }); // Formato HH:MM
    return `${formattedDate} ${formattedTime}`;
  };

  const commitChanges = () => {
    //return
    if (id) {
      const updatedValues = {
        id: id,
        name: name,
        user: user,
       
        description: description,
        enable: status,
        type: type,
  
      };
      Update(api_resource + '/' + id, updatedValues)
        .then(() => {
          //setRows((prevRows) => prevRows.map(r => (r.id === id ? updatedValues : r)));
          //updateRowType(id, updatedValues);
          getAllBots()
          handleClose()
          //alert.success('Parâmetro atualizado com sucesso!')
        })
        .catch((error) => {
          console.error("Erro ao atualizar:", error);
        });
    }
  }

  function getAllBots() {
    return http.get(`${api_resource}/all`);
  }

  const Update = (api_resource, data) => {
    return new Promise((resolve, reject) => {
      http.put(api_resource, data).then(
        (response) => {
          alert.success("Bot atualizado com sucesso!");
          resolve(response);
        },
        (error) => {
          alert.show("Erro ao atualizar o bot", { type: "error" });
          reject(error);
        }
      );
    });
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0]; // Acessa o arquivo selecionado
    const filePath = event.target.value
    if (file) {
      setCurFileName(file.name)
      setNewFile(file); // Armazena o arquivo no estado
      setNewFilePath(filePath)
    }
  };

  const UpdateDocument = () => {
    const formData = new FormData();
    formData.append('file', newFile); // Adiciona o arquivo ao FormData
    formData.append('id', id); // Adiciona outros dados necessários
    formData.append('user', JSON.stringify(user));
    return new Promise((resolve, reject) => {
      http.put(api_resource+'/document', formData, {headers: { 'Content-Type': 'multipart/form-data' }}).then(
        (response) => {
          alert.success("Documento atualizado com sucesso!");
          setOpen(false)
          resolve(response);
        },
        (error) => {
          alert.show("Erro ao atualizar o documento", { type: "error" });
          reject(error);
        }
      );
    });
  };


  const DownloadDocument = (documentData, fileName) => {
    if (typeof document === 'undefined') {
      console.error("document não está definido. Este código só pode ser executado no navegador.");
      return;
    }
  
    // Convertendo o array de bytes para um Blob
    const byteArray = new Uint8Array(documentData.data); // 'documentData.data' vem do backend, que é um array de bytes
    const blob = new Blob([byteArray], { type: 'application/octet-stream' }); // Defina o tipo MIME correto, dependendo do arquivo (ex. 'application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document')
    
    // Criando uma URL para o Blob
    const url = window.URL.createObjectURL(blob);
    
    // Criando um link temporário para o download
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName; // O nome do arquivo que será salvo
    link.click(); // Dispara o download
  
    // Libera a URL do objeto após o uso
    window.URL.revokeObjectURL(url);
  };
  

  //Modal
  const [selectedRow, setSelectedRow] = useState(null); 
  const [open, setOpen] = useState(false); 

  const handleClickOpen = (row) => {
    setSelectedRow(row);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  

  const TableRowComponent = ({ row, ...restProps }) => (
    <TableRow
       {...restProps}
       style={{ cursor: "pointer" }} // Cursor to indicate clickable row
       onClick={() => handleClickOpen(row)} // Event handler to open modal
    />
 );

  const userCanEdit = () => {
    const access = userAccess.find(access => access.name === 'Bots' && access.checked  && access.allow_edit);
    return access ? access.allow_edit : false;
  };

  const capitalizeFirstLetter = (str) => {
    if(!str)
       return
    return str
       .toLowerCase()
       .replace(/_/g, ' ') // Substitui "_" por espaço
       .split(' ')          // Divide a string em palavras
       .map(word => word.charAt(0).toUpperCase() + word.slice(1)) // Capitaliza cada palavra
       .join(' ');          // Junta as palavras de volta com espaços
  };

  // TODO - criar permissões para bots
  const userCanView = () => {
    if (user?.email === emailAdmin)
      return true
    if (user?.user_access?.some((e) => e.name === 'Bots')) //can view
      return true
    
    return false
  }

  const disableFields = () => {
    return !authenticatedUserContext.allow_edit('Bots')
  }
 
  useEffect(() => {
    //Set User
    if (user && user.user_access) {
      setUserAccess(user.user_access);
    }
  }, []); //[user]);

  useEffect(() => {
    getAllBots()
      .then((response) => {
        const data = response?.data || [];
        
        // Aplica a transformação no campo `changer_name`
        const transformedData = data.map((row) => ({
          ...row, // Mantém os outros campos
          developer_name: capitalizeFirstLetter(row.developer_name ?? ''),
          responsible_name: capitalizeFirstLetter(row.responsible_name ?? ''),
        }));
        setBots(transformedData);
      })
      .catch((error) => {
        console.error("Error fetching bots:", error);
      });
  }, []);

  useEffect(() => {
    if (selectedRow){
      setId(selectedRow.id ?? 0)
      setNewFile('')
      setNewFilePath('')
      setName(selectedRow.name ?? '')
      setType(selectedRow.type ?? '')
      setDeveloperName(selectedRow.developer_name ?? '')
      setResponsibleName(selectedRow.responsible_name ?? '')
      setCurDocument(selectedRow.document ?? '')
      setCurFileName(selectedRow.document_name ?? '')
      setDescription(selectedRow.description ?? '')
      setCreatedAt(selectedRow.created_at ?? '')
      setUpdatedAt(selectedRow.updated_at ?? '')
      
      //handleUpdateValue(selectedRow.value ?? '')
    }
  }, [selectedRow])

  

  return (
    <div id="wrapper">
      <Menu />
      <div id="page-wrapper" className="gray-bg">
        <Header/>
        <div className="row wrapper border-bottom white-bg page-heading">
          <div className="col-lg-10">
            <h2><i className="fa fa-android"></i>  Bots (WIP)</h2>
          </div>
        </div>
        <div className="wrapper wrapper-content animated fadeInRight">
          <div className="row">
            <div className="col-lg-12">
              <div className="ibox ">
                <div className="ibox-content">
                  {userCanView() ? (
                    <Grid rows={bots} columns={columns} getRowId={getRowId}>
                      <PagingState currentPage={pageIndex} pageSize={pageSize} onCurrentPageChange={setPageIndex} />
                      {/*<FilteringState filters={filters} onFiltersChange={handleFilters} />*/}
                      <Table columnExtensions={tableColumnExtensions} rowComponent={TableRowComponent}/>
                      <TableHeaderRow />
                      <TableColumnVisibility defaultHiddenColumnNames={defaultHiddenColumnNames} />
                      <DateTypeProvider for={["created_at"]} />
                      <StringTypeProvider for = {["developer_name", "document_name", "responsible_name", "description", "name"]}/>
                      <BooleanTypeProvider for={["enable"]}  />
                      <TypeProvider for={["type"]} />
                      <CustomPaging totalCount={totalItens} />
                      <PagingPanel />
                      <TableFixedColumns leftColumns={[TableEditColumn.COLUMN_TYPE]} />
                    </Grid>
                  ) : (
                    <div>{!selectedOption || selectedOption === '' ? '' : 'Você não tem acesso a esta automação.'}</div>
                  )}
                </div>

                <Dialog 
                  open={open} 
                  onClose={handleClose} 
                  maxWidth="md"
                  fullWidth
                  PaperProps={{
                    style: {
                      width: '800px', 
                      margin: '0 auto'
                    },
                  }}
                  >
                  
                <DialogTitle style={{ position: 'relative', color: "#3f51b5", textAlign: 'center' }}>
                  <span style={{ display: 'inline-block', width: '100%'}}>Editar Bot</span>
                  <IconButton
                      edge="end"
                      color="inherit"
                      onClick={handleClose}
                      aria-label="close"
                      style={{
                        position: 'absolute',
                        right: 30,
                        top: 20,
                        padding: 0
                      }}
                  >
                      <CloseIcon />
                  </IconButton>
                </DialogTitle>
                <Divider variant="fullWidth" />
                <DialogContent >
                  <DialogContentText style={{ color: "black" }}>
                      {selectedRow && (
                      <>
                        <MIUGrid container justifyContent="space-between">
                          <MIUGrid item xs={9} md={9} mt={2}>
                            <TextFieldLegivel
                              variant='outlined'
                              disabled={disableFields()}
                              fullWidth        
                              label="Nome"
                              value={name}
                              name="name"
                            />
                          </MIUGrid>
                          <MIUGrid item xs={3} md={3} mt={2}>
                            <TextFieldLegivel
                              variant='outlined'
                              disabled={true}
                              fullWidth        
                              label="Tipo"
                              value={type === 'bot' ? 'Bot' : type === 'automation' ? 'Automação' : 'Não Informado'}
                              name="type"
                              InputProps={{
                                endAdornment: (
                                  <InputAdornment position="end">{type === 'bot' ? <SmartToyIcon />: <SettingsIcon /> }</InputAdornment>
                                ),
                              }}
                            />
                          </MIUGrid>

                          <MIUGrid item xs={6} md={6} mt={2}>
                            
                            <TextField
                              variant='outlined'
                              disabled={disableFields()}
                              fullWidth        
                              label="Documento"
                              type="file"                           
                              onChange={(e) => handleFileChange(e)}
                              name="type"
                              InputLabelProps={{
                                shrink: true, // Controla o comportamento do rótulo ao usar `type="date"`
                              }}
                              InputProps={{
                                endAdornment: (
                                  <InputAdornment position="end"> {<AttachFileIcon />} </InputAdornment>
                                ),
                              }}
                            />
                            
                          </MIUGrid>
                          
                          <MIUGrid item xs={3} md={3} mt={2}>
                            <Button
                              style={{width: '95%', height: '56px', marginLeft: '10px'}}
                              disabled={!File}
                              variant="contained" 
                              onClick={() => {UpdateDocument()}} 
                              color="primary">  
                               <i class="fa fa-upload" aria-hidden="true"></i>&nbsp;Upload
                            </Button>
                          </MIUGrid>

                          <MIUGrid item xs={3} md={3} mt={2}>
                            <Button
                              style={{width: '95%', height: '56px', marginLeft: '10px'}}
                              disabled={!curDocument || !curFileName}
                              variant="contained" 
                              onClick={() => {DownloadDocument(curDocument, curFileName)}} 
                              color="primary">
                              <i class="fa fa-download" aria-hidden="true"></i>&nbsp;Download
                            </Button>
                          </MIUGrid>
                          <MIUGrid item xs={6} md={6} mt={2}>
                            <TextFieldLegivel
                              variant='outlined'
                              disabled={true}
                              fullWidth        
                              label="Desenvolvedor"
                              value={developerName}
                              name="type"
                              InputProps={{
                                endAdornment: (
                                  <InputAdornment position="end">{<CodeIcon/>}</InputAdornment>
                                ),
                              }}
                            />
                          </MIUGrid>
                          <MIUGrid item xs={6} md={6} mt={2}>
                            <TextFieldLegivel
                              variant='outlined'
                              disabled={true}
                              fullWidth        
                              label="Responsável"
                              value={responsibleName}
                              name="type"
                              InputProps={{
                                endAdornment: (
                                  <InputAdornment position="end">{ <FaceIcon/> }</InputAdornment>
                                ),
                              }}
                            />
                          </MIUGrid>


                          <MIUGrid item xs={12} md={12} mt={2}>
                            <span><i>Arquivo Atual: {curFileName || 'N/A'}</i></span>
                          </MIUGrid>
                          <MIUGrid item xs={12} md={12} mt={2}>
                            <TextFieldLegivel
                                multiline
                                minRows={10}
                                maxRows={20}
                                variant='outlined'
                                disabled={disableFields()}
                                fullWidth   
                                label="Descrição"
                                value={description}
                                name="description"
                                onChange={(e) => {setDescription(e.target.value)}}
                                
                              />
                          </MIUGrid>
                          <MIUGrid item xs={4} md={4} mt={2}>
                            <TextFieldLegivel
                              variant='outlined'
                              disabled={disableFields()}
                              fullWidth  
                              select 
                              label="Status"
                              value={status}
                              //name="format"
                              onChange={(e) => setStatus(e.target.value)}
                            >
                              <MenuItem value={true}>Ativo</MenuItem>
                              <MenuItem value={false}>Inativo</MenuItem>
                            </TextFieldLegivel>
                          </MIUGrid>
                          <MIUGrid item xs={4} md={4} mt={2}>
                            <TextFieldLegivel
                                variant='outlined'
                                disabled={true} 
                                fullWidth   
                                label="Criado em"
                                value={formatDateTime(createdAt)}
                                name="created_at"
                                InputProps={{
                                  endAdornment: (
                                    <InputAdornment position="end">{<DateRange/>}</InputAdornment>
                                  ),
                                }}
                              />
                          </MIUGrid>
                          <MIUGrid item xs={4} md={4} mt={2}>
                            <TextFieldLegivel
                                variant='outlined'
                                disabled={true} 
                                fullWidth   
                                label="Ultima atualização"
                                value={formatDateTime(updatedAt)}
                                name="updated_at"
                                InputProps={{
                                  endAdornment: (
                                    <InputAdornment position="end">{<DateRange/>}</InputAdornment>
                                  ),
                                }}
                              />
                          </MIUGrid>
                        </MIUGrid> {/* container */}
                      </>
                      )}
                  </DialogContentText>
                </DialogContent>
                <DialogActions>
                  <Button style={{ marginBottom: 12, marginTop: 12}} onClick={handleClose} color="primary">
                    Fechar
                  </Button>
                  <Button 
                    style={{marginRight: 30, marginBottom: 12, marginTop: 12}}
                    disabled={true}
                    variant="contained" 
                    onClick={commitChanges} 
                    color="primary">
                    Salvar
                  </Button>
                </DialogActions>
                  <Snackbar
                    open={snackbarOpen}
                    autoHideDuration={3000}
                    onClose={handleCloseSnackbar}
                    anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                  >
                    <Alert onClose={handleCloseSnackbar} severity="success" variant="filled">
                      Texto copiado para a área de transferência!
                    </Alert>
                  </Snackbar>
                </Dialog>
                
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BotTable;
